import React from 'react';
import {
    Card,
    CardHeader,
    CardContent,
    Grid,
    TextField,
    Button,
    IconButton,
    Tooltip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
		LinearProgress,
		Typography,
		Select,
		MenuItem,
		FormControl,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import LaunchIcon from '@material-ui/icons/Launch';
import SaveIcon from '@material-ui/icons/Save';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    card: {
        marginBottom: theme.spacing(3),
    },
    table: {
        minWidth: 650,
        '& .MuiTableCell-root': {
            borderBottom: 'none',
            padding: theme.spacing(1.5),
        },
        '& .MuiTableRow-root': {
            '&:hover': {
                backgroundColor: theme.palette.action.hover,
            },
        },
    },
    link: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: theme.palette.primary.main,
        marginLeft: theme.spacing(1),
    },
	label: {
		cursor: 'default',
		display: 'flex',
		alignItems: 'center',
		textDecoration: 'none',
		color: "black",
		marginLeft: theme.spacing(1),
	},
    button: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    progress: {
        backgroundColor: theme.palette.grey[500],
    },
}));

const ShippingAndTrackingInfo = ({
                                     details,
                                     trackingEvent,
                                     packageQuantity,
                                     setPackageQuantity,
                                     packageWeight,
                                     setPackageWeight,
                                     extShippingCost,
                                     setExtShippingCost,
                                     extPackingCost,
                                     setExtPackingCost,
	                                 extShippingCostCurrency,
	                                 setExtShippingCostCurrency,
                                     handleSavePackage,
                                     handleGoToCambodiaPost,
                                     dialogLoading,
                                     colors,
	                                 courierCompany,
	                                 trackingCode
                                 }) => {
	const classes = useStyles();

	return (
		<Grid>
			{/* Shipping Section */}
			{(details.status > 2 && details.status !== 7 && details.external_courier === 0) && (
				<Grid item xs={12}>
					<Card className={classes.card}>
						<CardHeader title={<Typography variant="h6"><b>SHIPPING</b></Typography>}/>
						<CardContent>
							<Grid container spacing={2}>
								{/* Package Quantity */}
								<Grid item xs={12} className="flex items-center">
									<Grid container alignItems="center">
										<Grid item xs={4}>
											<Typography variant="body1" className="font-weight-bold">
												Package quantity
											</Typography>
										</Grid>
										<Grid item xs={8}>
											<TextField
												variant="outlined"
												fullWidth
												type="number"
												placeholder={"0"}
												inputProps={{inputMode: "numeric", pattern: "[1-9]*"}}
												value={packageQuantity}
												onChange={(e) => setPackageQuantity(e.target.value)}
												className="bg-white"
												size="small"
											/>
										</Grid>
									</Grid>
								</Grid>

								{/* Package Weight */}
								<Grid item xs={12} className="flex items-center">
									<Grid container alignItems="center">
										<Grid item xs={4}>
											<Typography variant="body1" className="font-weight-bold">
												Package weight
											</Typography>
										</Grid>
										<Grid item xs={8}>
											<TextField
												variant="outlined"
												fullWidth
												value={packageWeight}
												onChange={(e) => setPackageWeight(e.target.value)}
												className="bg-white"
												size="small"
											/>
										</Grid>
									</Grid>
								</Grid>

								{/* External Shipping Cost */}
								<Grid item xs={12} className="flex items-center">
									<Grid container alignItems="center">
										<Grid item xs={4}>
											<Typography variant="body1" className="font-weight-bold">
												Shipping cost
											</Typography>
										</Grid>
										<Grid item xs={5}>
											<TextField
												variant="outlined"
												fullWidth
												type="number"
												placeholder={"0"}
												inputProps={{inputMode: "numeric", pattern: "[0-9.]*", step: "0.01"}}
												value={extShippingCost}
												onChange={(e) => setExtShippingCost(e.target.value)}
												className="bg-white"
												size="small"
											/>
										</Grid>
										<Grid item xs={3} style={{paddingLeft: '8px'}}>
											<FormControl variant="outlined" fullWidth size="small">
												<Select
													value={extShippingCostCurrency || 'KHR'}
													onChange={(e) => setExtShippingCostCurrency(e.target.value)}
													className="bg-white"
												>
													<MenuItem value="KHR">KHR</MenuItem>
													<MenuItem value="USD">USD</MenuItem>
												</Select>
											</FormControl>
										</Grid>
									</Grid>
								</Grid>

								{/* External Packing Cost */}
								<Grid item xs={12} className="flex items-center">
									<Grid container alignItems="center">
										<Grid item xs={4}>
											<Typography variant="body1" className="font-weight-bold">
												Extra packing materials costs(KHR)
											</Typography>
										</Grid>
										<Grid item xs={8}>
											<TextField
												variant="outlined"
												fullWidth
												placeholder={"0"}
												inputProps={{inputMode: "numeric", pattern: "[1-9]*"}}
												type="number"
												value={extPackingCost}
												onChange={(e) => setExtPackingCost(e.target.value)}
												className="bg-white"
												size="small"
											/>
										</Grid>
									</Grid>
								</Grid>

                                {/* Save Button */}
                                <Grid item xs={12} className="flex justify-end">
                                    <Button
                                        startIcon={<SaveIcon />}
                                        variant="contained"
                                        size="small"
                                        onClick={handleSavePackage}
                                        style={{
                                            backgroundColor: colors.primary,
                                            color: '#fff',
                                        }}
                                    >
                                        Save Package
                                    </Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            )}
            {/* Tracking Info Section */}
            <Grid item xs={12} className={"h-100"}>
                <Card className={classes.card}>
                    <CardHeader title={<Typography variant="h6"><b>TRACKING INFO</b></Typography>} />
                    <CardContent>
                        {dialogLoading && (
                            <Grid item xs={12}>
                                <LinearProgress className={classes.progress} />
                            </Grid>
                        )}
                        {trackingEvent?.length > 0 && (
                            <Grid item xs={12}>
	                            <div style={{display: 'flex', alignItems: 'center'}}>
		                            <b>Events Tracking</b>
		                            <Tooltip title={`Go to ${courierCompany} website`}>
			                            <a onClick={trackingEvent[0]?.allow_open_website && handleGoToCambodiaPost}
			                               className={trackingEvent[0]?.allow_open_website ? classes.link : classes.label}>
				                            ({trackingCode || 'N/A'} <LaunchIcon
				                            style={{color: colors.blue, fontSize: '16px'}}/>)
			                            </a>
		                            </Tooltip>
	                            </div>
                                <TableContainer>
                                    <Table className={classes.table} aria-label="tracking table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left">Event date/time</TableCell>
                                                <TableCell align="left">Event type</TableCell>
                                                <TableCell align="left">Display Status</TableCell>
                                                <TableCell align="left">Signatory name</TableCell>
                                                <TableCell align="left">Next office</TableCell>
                                                <TableCell align="right">Reason</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {trackingEvent
                                                .map((row, idx) => (
                                                    <TableRow key={row.name || idx}>
                                                        <TableCell align="left">{moment(row?.event_date).format('YYYY-MM-DD HH:mm:ss')}</TableCell>
                                                        <TableCell align="left">{row?.event_type || '-'}</TableCell>
                                                        <TableCell align="left">{row?.display_description || '-'}</TableCell>
                                                        <TableCell align="left">{row?.signatory_nm || '-'}</TableCell>
                                                        <TableCell align="left">{row?.next_office || '-'}</TableCell>
                                                        <TableCell align="right">{row?.reason || '-'}</TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        )}
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default ShippingAndTrackingInfo;